<template>
  <div class="faq-wrapper">
    <div class="faqs-about-background">
      <div
        data-aos="fade-up"
        data-aos-offset="200"
        data-aos-delay="50"
        data-aos-duration="1000"
        data-aos-easing="ease-in-out"
        class="faqs-title-container"
      >
        <h4>Answers</h4>
        <h2 class="faqs-header-title">Questions</h2>
        <img class="faqs-title-logo" :src="faq" />
      </div>
    </div>

    <div class="faq-container">
      <div class="left-side-decoration">
        <img class="left-side-image" :src="peace1" />
      </div>
      <div class="wrapper-end">
        <VueFaqAccordion class="vuefaq" :items="myItems" />
      </div>
      <div class="right-side-decoration">
        <img class="right-side-image" :src="peace2" />
      </div>
    </div>
  </div>
</template>

<script>
import VueFaqAccordion from "vue-faq-accordion";
export default {
  components: {
    VueFaqAccordion,
  },
  name: "ProductGuide",
  data() {
    return {
      faq: require("@/assets/images/calli-great.png"),
      peace1: require("@/assets/images/peace-japanese1.png"),
      peace2: require("@/assets/images/peace-japanese2.png"),
      myItems: [
        {
          title: "Kan man gjøre endringer på menyen?",
          value:
            "Ja, du kan gjøre endringer på menyen så langt vi klarer å få til. F.eks legge til eller ta bort noe ingredienser, eller bytte nigiri mot andre fisketyper nigiri og maki mot andre typer maki.",
          category: "Bestilling",
        },
        {
          title: "Kan dere bruke noe annet enn sjøtang for makiene deres?",
          value:
            "Vi kan bruke rispapir og tufoplater i stedet for nori(sjøtang), for de som ikke er så glade i det",
          category: "Bestilling",
        },
        {
          title: "Hva skjer når vi får levert feil mat?",
          value:
            "Ta kontakt med oss via tlf. dersom det er noe vi kan rette opp øyeblikkelig, eller send bilde av maten og kvitteringen til  ks@fujisushi.no, så ordner vi opp i form av gavekort eller tilgodelapp. Vi setter pris på at klagen rettes snarest mulig til oss, og ikke flere dager senere :)",
          category: "Bestilling",
        },
        {
          title: "Vi ønsker å reklamere på maten, hvordan?",
          value:
            "Ta kontakt med oss via tlf. dersom det er noe vi kan rette opp øyeblikkelig, eller send bilde av maten og kvitteringen til  ks@fujisushi.no, så ordner vi opp i form av gavekort eller tilgodelapp. Vi setter pris på at klagen rettes snarest mulig til oss, og ikke flere dager senere :)",
          category: "Bestilling",
        },
        {
          title:
            "Er det farlig å spise sushien hvis det har stått for lenge i romtemperatur?",
          value:
            "Den sure sushi-risen bidrar til å hemme oppvekst av bakterier i sushi, viser forskning utført ved matforskningsinstituttet Nofima. Den har god effekt også når det er varmt, sushibitene kan stå i noen timer i romtemperatur uten nedkjøling.",
          category: "Helse",
        },
        {
          title: "Lager dere mat til store selskaper?",
          value:
            "Ja, vi caterer til selskaper som bursdag, konfirmasjon, bryllup ect. Vi er også behjelpelig med å kombinere den perfekte menyen til alle anledningene og smak.",
          category: "Bestilling",
        },
        {
          title: "Kan gravide spise sushi?",
          value:
            "Ja, absolutt! Gravide trenger ikke å unngå sushi så lenge villfangst-fisk fryses til en indre temperatur på minst -20C i minst 24 timer. Likevel skal ikke tunfisk spises under graviditet pga. miljøgifter i store fisk over tid. Norsk oppdrettlaks er ikke pålagt å innfryse.",
          category: "Helse",
        },
        {
          title: "Får man kvittering når man bestiller online?",
          value:
            "Ja, kvittering for kjøpet blir sendt til din oppgitte epost adresse. Sjekk gjerne SPAM/ søppelpost.",
          category: "Bestilling",
        },
        {
          title: "Hvor mange sushi biter anbefaler dere til 1 person?",
          value:
            "Vi anbefaler ca 10-12 biter til lunsj, og ca 15-20 til middag.",
          category: "Bestilling",
        },
        ,
        {
          title: "Holder dere sushi kurs?",
          value: "Nei, vi har dessverre ikke kapasitet per dags dato.",
          category: "Diverse",
        },
        {
          title: "Holder dere sushi kurs?",
          value: "Nei, vi har dessverre ikke kapasitet per dags dato.",
          category: "Bestilling",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;1,300&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap");
@import url("~@/assets/css/components.css");
@import url("~@/assets/css/normalize.css");

$desktop: 1200px;
$laptop: 1024px;
$tablet: 768px;
$mobile: 480px;

.faq-container {
  display: flex;
  justify-content: space-evenly;
  line-height: 25px;
}

.left-side-image {
  width: 9rem;
  height: auto;
  padding-top: 10rem;
}

.right-side-image {
  width: 9rem;
  height: auto;
  padding-top: 10rem;
}

.wrapper-end {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 100px;
  width: 50em;
  max-width: 825px;

  font-size: 20px;
  padding-top: 50px;
}
#app .vuefaq .faq-wrapper {
  font-family: Roboto;
}
.faqs-about-background {
  background-image: url("~@/assets/images/chef-team.jpg");
  background-size: cover;
  height: 490px;
  width: 100%;
  object-fit: cover;
  margin-top: 10px;
  display: grid;
  place-items: center;

  @media (max-width: $mobile) {
    height: 200px;
    position: static;
    bottom: 0;
  }
}
.faqs-title-container {
  background-color: white;

  height: 200px;
  width: 18%;
  border-radius: 50px;
  display: grid;
  place-items: center;
  @media (max-width: $mobile) {
    height: 100px;
    width: 50%;
    border-radius: 30px;
  }
}
h4 {
  text-align: center;
  font-family: Roboto, sans-serif;
  font-weight: 400 !important;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #878787;
  position: relative;
  top: 25px;
  @media (max-width: $mobile) {
    font-size: 1em;
    top: 10px;
  }
}
.faqs-header-title {
  text-align: center;
  text-transform: uppercase;
  font-family: Bebas;
  font-weight: 400;
  margin: 0 0 0.67em 0;
  font-size: 2vw;
  margin: 0;
  @media (max-width: $mobile) {
    font-size: 2em;
    position: relative;
    bottom: 10px;
  }
}
.faqs-title-logo {
  position: relative;
  bottom: 20px;
  width: 80px;
  @media (max-width: $mobile) {
    height: 60px;
    width: auto;
  }
}

.ant-layout {
  height: 100% !important;
}
</style>
